import React from 'react';
import { useIntersect } from 'global/hooks/useIntersect';
import { NavToTopFab, NavToTopWrapper } from './NavToTop.styles';
import { get } from 'global/lib/lodash';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Tooltip from '@mui/material/Tooltip';

export default function NavToTop(props) {
  const [ref, inView] = useIntersect({ rootMargin: '0px' });
  const canBeVisible = !('visible' in props) || props.visible;
  const visible = canBeVisible && !get(inView, 'isIntersecting', false);

  const onClick = () => {
    const hasClick = get(props, 'onClick');
    if (hasClick) {
      hasClick();
    } else {
      window.scroll(0, 0);
    }
  };

  return (
    <>
      <div ref={ref} id={'navToTop'} />
      <NavToTopWrapper visible={visible}>
        <Tooltip title="Scroll To Top">
          <NavToTopFab size="small" onClick={onClick}>
            <KeyboardArrowUpIcon />
          </NavToTopFab>
        </Tooltip>
      </NavToTopWrapper>
    </>
  );
}
